<template>
  <b-modal
    hide-footer
    id="modal-transfer"
    ref="modal-transfer"
    size="xl"
    title="ยืนยันข้อมูล"
  >
  <div class="container">
<b-card>
      <b-row>
        <b-col cols="12">
          <h4>เรื่องร้องทุกข์ที่ส่งต่อ</h4>

          <CommonTable :rows="complaints"> </CommonTable>
        </b-col>

        <b-col cols="12">
          <b-form-group label="ส่งต่อไปยังเจ้าหน้าที่">
            <!-- <span class="text-danger">**โปรดระบุข้อมูลอย่างละเอียด เพื่อความรวดเร็วในการดำเนินการของเจ้าหน้าที่</span> -->
            <b-form-input :value="person.text" :readonly="true" rows="10" />
          </b-form-group>

          <b-form-group label="ความเห็นเจ้าหน้าที่">
            <!-- <span class="text-danger">**โปรดระบุข้อมูลอย่างละเอียด เพื่อความรวดเร็วในการดำเนินการของเจ้าหน้าที่</span> -->
            <b-form-textarea
              :value="comment"
              placeholder="ความเห็นเจ้าหน้าที่"
              :v-text="comment"
              :readonly="true"
              rows="10"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <footer id="modal-transfer___BV_modal_footer_" class="modal-footer d-flex justify-content-between">
        <button type="button" class="btn btn-secondary" block @click="onCancel">
          ยกเลิก
        </button>
        <button type="button" class="btn btn-primary" block @click="onSubmit">
          บันทึก
        </button>
      </footer>
    </b-card>
  </div>
    
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import vSelect from "vue-select";

import CommonTable from "./commonTableModal";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    CommonTable,
    BCard,
  },
  props: {
    complaints: {
      type: Array,
    },
    comment: {
      type: String,
      default: "",
    },
    person: {
      type: Object,
    },
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
    };
  },
  created() {},
  methods: {
    onSubmit() {
      this.$emit("handle-submit");
    },
    onCancel() {
      this.$refs["modal-transfer"].hide();
    }
  },
};
</script>

<style></style>
